import React from "react";
import ReactDOM from "react-dom";

const InspectorContext = React.createContext([]);

export const InspectorProvider = (props) => {
  const inspectorState = React.useState(null);
  return <InspectorContext.Provider value={inspectorState} {...props} />;
};

export const Inspector = () => {
  const [, setInspector] = React.useContext(InspectorContext);
  return <div ref={setInspector} />;
};

export const InspectorPortal = ({ children }) => {
  const [inspector] = React.useContext(InspectorContext);
  return inspector ? ReactDOM.createPortal(children, inspector) : null;
};
